<template>
  <div>
    <div class="wrapper-title d-flex align-items-center">
      <div class="page-title font-weight-bold">
        <div>
          {{titles.join(" / ")}}
        </div>
        <div class="ml-1" v-if="!hideCount">({{ dataCount }})</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    titles: {
      type: Array,
      required: true
    },
    dataCount: {
      type: Number,
      default: 0
    },
    hideCount: {
      type: Boolean,
      default: false
    },
  }
}
</script>

<style scoped>
.wrapper-title {
  height: var(--size-bars);
}
</style>